<template>
    <div>
        <div class="content-header">
            <PageTitleComponent title="Gestión de butacas"/>
        </div>
        <section class="content">
            <div class="container-fluid">
                <div class="card card-primary card-outline card-outline-tabs">
                    <div class="card-header p-0 border-bottom-0">
                        <ul class="nav nav-tabs" id="custom-tabs-five-tab" role="tablist">
                            <li class="nav-item" v-if="place.svg_teatros">
                                <a 
                                    :class="tab == 'region' ? 'nav-link active' : 'nav-link'" 
                                    href="#"
                                    @click.prevent="changeTab('region')"
                                >
                                    Región
                                </a>
                            </li>
                            <li class="nav-item" v-if="place.url_svg_asientos">
                                <a 
                                    :class="tab == 'planoGeneral' ? 'nav-link active' : 'nav-link'" 
                                    href="#"
                                    @click.prevent="changeTab('planoGeneral')"
                                >
                                    Plano general
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="card-body">
                        <div class="tab-content">
                            <div class="tab-pane fade active show">
                                <transition name="fade" mode="out-in">
                                    <div key="1" class="overlay-wrapper" v-if="tab == 'region'">
                                        <RegionesTab />
                                    </div>
                                    <div key="2" class="overlay-wrapper" v-if="tab == 'planoGeneral'">
                                        <PlanoGeneralTab/>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>             
            </div>
        </section>      
    </div>
</template>

<script>
    import PageTitleComponent from '@/components/backend/components/PageTitleComponent';
    import PlanoGeneralTab from './tabs/PlanoGeneralTab.vue';
    import RegionesTab from './tabs/RegionesTab.vue';

    export default {
        data() {
            return {
                tab: 'region'
            }
        },
        methods: {
            changeTab(tabName) {
                this.tab = tabName;
            }
        },
        mounted() {
            if (!this.place.url_svg_asientos) {
                this.tab = 'region';
            } else {
                this.tab = 'planoGeneral';
            }
        },
        computed: {
            place() {
                return this.$store.getters.getRecinto;
            },
        },
        components: {
            PageTitleComponent, PlanoGeneralTab, RegionesTab
        }
    }
</script>
